import toCurrency from "./toCurrency";
import toUpperCase from "./toUpperCase";
import toFormattedDate from "./toFormattedDate";

export default {
  toCurrency,
  toUpperCase,
  toFormattedDate,
};
